import { errors } from '@feathersjs/client';
export var WORKSPACE_EVENT_RESET = 'WORKSPACE_EVENT_RESET';
export var WORKSPACE_EVENT_SET_USER_EVENT_ROLES = 'WORKSPACE_EVENT_SET_USER_EVENT_ROLES';
export var WORKSPACE_EVENT_SET_EVENT = 'WORKSPACE_EVENT_SET_EVENT';
export var WORKSPACE_EVENT_SET_CATEGORIES = 'WORKSPACE_EVENT_SET_CATEGORIES';
export var WORKSPACE_EVENT_SET_ROUNDS = 'WORKSPACE_EVENT_SET_ROUNDS';
export var WORKSPACE_EVENT_SET_ROUND_BIBS = 'WORKSPACE_EVENT_SET_ROUND_BIBS';
export var WORKSPACE_EVENT_SET_ROUTES = 'WORKSPACE_EVENT_SET_ROUTES';
export var WORKSPACE_EVENT_SET_TEAMS = 'WORKSPACE_EVENT_SET_TEAMS';
export var WORKSPACE_EVENT_SET_TEAM_SCORES = 'WORKSPACE_EVENT_SET_TEAM_SCORES';
export var WORKSPACE_EVENT_SET_ATHLETES = 'WORKSPACE_EVENT_SET_ATHLETES';
export var WORKSPACE_EVENT_SET_ATHLETE_SCORES = 'WORKSPACE_EVENT_SET_ATHLETE_SCORES';
export var WORKSPACE_EVENT_SET_ATHLETE_SCORE_ROUTES = 'WORKSPACE_EVENT_SET_ATHLETE_SCORE_ROUTES';
export var WORKSPACE_EVENT_SET_ACTIVES = 'WORKSPACE_EVENT_SET_ACTIVES';
export var WORKSPACE_EVENT_SET_NOTIFICATIONS = 'WORKSPACE_EVENT_SET_NOTIFICATIONS';
export var resetWorkspaceEvent = function () {
    return {
        type: WORKSPACE_EVENT_RESET,
    };
};
export var setWorkspaceEventUserEventRoles = function (userEventRoles) {
    return {
        type: WORKSPACE_EVENT_SET_USER_EVENT_ROLES,
        payload: { userEventRoles: userEventRoles },
    };
};
export var setWorkspaceEventEvent = function (event) {
    return {
        type: WORKSPACE_EVENT_SET_EVENT,
        payload: { event: event },
    };
};
export var setWorkspaceEventCategories = function (categories) {
    return {
        type: WORKSPACE_EVENT_SET_CATEGORIES,
        payload: { categories: categories },
    };
};
export var setWorkspaceEventRounds = function (rounds) {
    return {
        type: WORKSPACE_EVENT_SET_ROUNDS,
        payload: { rounds: rounds },
    };
};
export var setWorkspaceEventRoundBibs = function (roundBibs) {
    return {
        type: WORKSPACE_EVENT_SET_ROUND_BIBS,
        payload: { roundBibs: roundBibs },
    };
};
export var setWorkspaceEventRoutes = function (routes) {
    return {
        type: WORKSPACE_EVENT_SET_ROUTES,
        payload: { routes: routes },
    };
};
export var setWorkspaceEventTeams = function (teams) {
    return {
        type: WORKSPACE_EVENT_SET_TEAMS,
        payload: { teams: teams },
    };
};
export var setWorkspaceEventTeamScores = function (teamScores) {
    return {
        type: WORKSPACE_EVENT_SET_TEAM_SCORES,
        payload: { teamScores: teamScores },
    };
};
export var setWorkspaceEventAthletes = function (athletes) {
    return {
        type: WORKSPACE_EVENT_SET_ATHLETES,
        payload: { athletes: athletes },
    };
};
export var setWorkspaceEventAthleteScores = function (athleteScores) {
    return {
        type: WORKSPACE_EVENT_SET_ATHLETE_SCORES,
        payload: { athleteScores: athleteScores },
    };
};
export var setWorkspaceEventAthleteScoreRoutes = function (athleteScoreRoutes) {
    return {
        type: WORKSPACE_EVENT_SET_ATHLETE_SCORE_ROUTES,
        payload: { athleteScoreRoutes: athleteScoreRoutes },
    };
};
export var setWorkspaceEventActives = function (actives) {
    return {
        type: WORKSPACE_EVENT_SET_ACTIVES,
        payload: { actives: actives },
    };
};
export var setWorkspaceEventNotifications = function (notifications) {
    return {
        type: WORKSPACE_EVENT_SET_NOTIFICATIONS,
        payload: { notifications: notifications },
    };
};
export var setWorkspaceEventService = function (service, data) {
    switch (service) {
        case 'userEventRoles':
            return setWorkspaceEventUserEventRoles(data);
        case 'categories':
            return setWorkspaceEventCategories(data);
        case 'rounds':
            return setWorkspaceEventRounds(data);
        case 'roundBibs':
            return setWorkspaceEventRoundBibs(data);
        case 'routes':
            return setWorkspaceEventRoutes(data);
        case 'teams':
            return setWorkspaceEventTeams(data);
        case 'teamScores':
            return setWorkspaceEventTeamScores(data);
        case 'athletes':
            return setWorkspaceEventAthletes(data);
        case 'athleteScores':
            return setWorkspaceEventAthleteScores(data);
        case 'athleteScoreRoutes':
            return setWorkspaceEventAthleteScoreRoutes(data);
        case 'actives':
            return setWorkspaceEventActives(data);
        case 'notifications':
            return setWorkspaceEventNotifications(data);
        default:
            throw new errors.NotImplemented("Service \"" + service + "\" is not recognized by setWorkspaceEventService");
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/workspaceEvent/actions.ts
// module id = 185
// module chunks = 0